export let appExcel = "EuKDwc";
export default {appExcel};